module.exports = "<div class=\"bg\">\n\n</div>\n"